import { ShareAltOutlined } from '@ant-design/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Button, useMessage } from 'components/ui';
import { useAccountContext } from 'utils/account/AccountContext';

const ShareUrlButton = styled(Button)`
  background: none;
  border: none;
  box-shadow: none;
  margin-top: 1.25rem;
  position: relative;

  svg {
    height: 1.25rem;
    width: 1.25rem;
  }
`;

export default function CopyUrlButton() {
  const { t } = useTranslation();
  const message = useMessage();
  const { customer } = useAccountContext();
  const { pathname, search } = useLocation();
  const customerId = customer?.id;
  const newUrl = customerId ? `${window.location.origin}/o/${customerId}${pathname}${search}` : '';

  return (
    <CopyToClipboard
      text={newUrl}
      onCopy={() =>
        customerId &&
        message.success(t('notifications.success.urlCopied', 'Page URL copied to clipboard'))
      }
    >
      <ShareUrlButton
        icon={<ShareAltOutlined />}
        shape="circle"
        title={t('components.copyPageUrl', 'Copy page URL')}
        disabled={!customerId}
      />
    </CopyToClipboard>
  );
}
